// Images
import CumulativeActionsImage from './images/cumulative_actions.svg';
import TimeSpentInMeetingsImage from './images/time_spent_in_meetings.svg';
import RelationshipCadenceImage from './images/relationship_cadence.svg';
import KeyManagementActivitiesImage from './images/key_management_activities.svg';
import WorkpaceAcitivityImage from './images/workspace_activity.svg';
import TeamGoalsImage from './images/team_goals.svg';
import CoachingSummaryImage from './images/coaching_summary.svg';

export enum MetricSlugs {
  cumulative_actions = 'cumulative_actions',
  time_in_meetings = 'time_in_meetings',
  interactions_with_teammates = 'interactions_with_teammates',
  key_management_activties = 'key_management_activties',
  workspace_activity = 'workspace_activity',
  coaching_summary = 'coaching_summary',
  team_goals = 'team_goals',
}

export type DataType = {
  slug: string;
  title: string;
  label: string;
  description: string;
  image?: string;
};

export const ManagerDashboardLearnMoreData = [
  {
    slug: MetricSlugs.cumulative_actions,
    title: 'Cumulative actions taken',
    label: 'Team Activity',
    image: CumulativeActionsImage,
    description:
      'Keep track of your teams activities such as, discussion topics, action items, comments, feedback, kudos, and goals taken within PI Perform.',
  },
  {
    slug: MetricSlugs.time_in_meetings,
    image: TimeSpentInMeetingsImage,
    label: 'Meeting Time',
    title: 'Time in meetings',
    description: 'Track your average time spent in meetings per week based on your synced calendar.',
  },
  {
    slug: MetricSlugs.interactions_with_teammates,
    image: RelationshipCadenceImage,
    label: 'Relationship Cadence',
    title: 'Interactions with your teammates',
    description:
      'Keep track of the quantity of interactions you’re having with each of your teammates in both 1:1 and team meetings.',
  },
  {
    slug: MetricSlugs.key_management_activties,
    image: KeyManagementActivitiesImage,
    label: 'Management Scorecard',
    title: 'Key Management Activities',
    description: 'Your scorecard shows the completions of key management activities for each person you engage with.',
  },
  {
    slug: MetricSlugs.workspace_activity,
    image: WorkpaceAcitivityImage,
    label: 'Workspace Activity',
    title: 'Discussion Topics and Action Items',
    description:
      'Access a summary of discussion topics and action items in both 1:1 and group workspaces for each person on your team.',
  },
  {
    slug: MetricSlugs.coaching_summary,
    image: CoachingSummaryImage,
    title: 'Feedback and Kudos',
    label: 'Feedback Summary',
    description:
      'Keep track of the feedback and kudos given and received for each person with whom you have a workspace.',
  },
  {
    slug: MetricSlugs.team_goals,
    image: TeamGoalsImage,
    label: 'Team Goals',
    title: 'Goals',
    description:
      'Get an overview of the number of public and private goals each person has owned (created) and completed during the timeframe.',
  },
] as Array<DataType>;
